module.exports = __webpack_public_path__ + "static/img/kf2.85bf3702.png";